import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse, UserConfirm } from 'types';

interface UpdateUserParams {
  userName?: string;
  description?: string;
  confirm?: UserConfirm;
}

type UpdateUser = (params: UpdateUserParams) => Promise<ApiResponse>;

const updateUser: UpdateUser = async ({ userName, description, confirm }) => {
  const { data } = await apiClient.put(API_END_POINT.USER.UPDATE_USER, {
    ...(userName && { userName }),
    ...(description && { description }),
    ...(confirm && {
      confirm,
    }),
  });

  return data;
};

export default updateUser;
